import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { Course } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetModalCourses() {
	return useQuery<Pick<Course, 'course_id' | 'course_name'>[]>({
		queryKey: ['get-modal-courses', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('courses')
				.select('course_name, course_id')
				.eq('school_id', schoolId)
				.order('course_name', { ascending: true });

			if (error) throw error;

			return (data ?? []) as unknown as Pick<Course, 'course_id' | 'course_name'>[];
		},
	});
}
